// AstrologyContent.js - Birth Chart Form
import React, { useState, useRef } from "react";
import SouthIndianChart from "./SouthIndianChart";

function fmtDate(d) {
  if (!d) return "";
  try { return new Date(d).toLocaleDateString("en-IN", {year:"numeric",month:"short",day:"numeric"}); }
  catch { return d; }
}
const BACKEND = process.env.REACT_APP_BACKEND_URL || "https://nethajiprime-backend.onrender.com";

export default function AstrologyContent() {
  const [lang, setLang] = useState("ta");
  const [form, setForm] = useState({ name: "", dob: "", time_of_birth: "06:00", place_of_birth: "" });
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const resultRef = useRef(null);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError(null); setResult(null);
    try {
      const resp = await fetch(BACKEND + "/api/astrology/horoscope", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...form, language: lang }),
      });
      if (!resp.ok) { const err = await resp.json().catch(()=>({})); throw new Error(err.detail || "Error " + resp.status); }
      const data = await resp.json();
      console.log('API Response:', JSON.stringify(data));
      setResult(data);
      setTimeout(() => resultRef.current?.scrollIntoView({ behavior: "smooth" }), 100);
    } catch (err) { setError(err.message); }
    finally { setLoading(false); }
  };

  const S = {
    wrap: { background: "linear-gradient(135deg,#0f0c29,#302b63,#24243e)", minHeight: "60vh", padding: "clamp(8px,3vw,24px) clamp(8px,4vw,16px)", fontFamily: "Segoe UI, sans-serif", color: "#e2e8f0" },
    card: { background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: "16px", padding: "24px", maxWidth: "600px", margin: "0 auto 24px", width: "100%", boxSizing: "border-box" },
    title: { fontSize: "clamp(18px,5vw,28px)", fontWeight: 800, background: "linear-gradient(90deg,#f6d365,#fda085)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", textAlign: "center", marginBottom: "20px" },
    label: { fontSize: "13px", color: "#94a3b8", fontWeight: 600, display: "block", marginBottom: "4px" },
    input: { width: "100%", padding: "10px 14px", background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.15)", borderRadius: "8px", color: "#e2e8f0", fontSize: "15px", outline: "none", boxSizing: "border-box", marginBottom: "12px" },
    btn: { width: "100%", padding: "14px", borderRadius: "10px", border: "none", background: "linear-gradient(135deg,#7C3AED,#9333EA)", color: "#fff", fontSize: "16px", fontWeight: 700, cursor: "pointer", marginTop: "8px" },
    row: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))", gap: "12px", marginBottom: "12px" },
    box: { background: "rgba(255,255,255,0.06)", borderRadius: "10px", padding: "14px", border: "1px solid rgba(255,255,255,0.08)", marginBottom: "10px" },
    boxLabel: { fontSize: "11px", color: "#64748b", textTransform: "uppercase", letterSpacing: "1px" },
    boxTa: { fontSize: "22px", fontWeight: 800, color: "#f6d365" },
    boxEn: { fontSize: "13px", color: "#94a3b8" },
    err: { background: "rgba(239,68,68,0.1)", border: "1px solid rgba(239,68,68,0.3)", borderRadius: "10px", padding: "14px", color: "#fca5a5", textAlign: "center", maxWidth: "600px", margin: "0 auto" },
  };

  const L = {
    title: lang === "ta" ? "ஜனன குணப்படம்" : "Birth Chart",
    name: lang === "ta" ? "பெயர்" : "Name",
    dob: lang === "ta" ? "பிறந்த தேதி" : "Date of Birth",
    time: lang === "ta" ? "பிறந்த நேரம்" : "Time of Birth",
    place: lang === "ta" ? "பிறந்த இடம்" : "Place of Birth",
    submit: lang === "ta" ? "கணக்கிடு" : "Get Horoscope",
    loading: lang === "ta" ? "கணக்கிடுகிறோம்..." : "Calculating...",
  };

  return (
    <div style={S.wrap}>
      <div style={S.card}>
        <div style={S.title}>{L.title}</div>
        <div style={{textAlign:"center",marginBottom:"16px",display:"flex",gap:"8px",justifyContent:"center"}}>
          <button style={{padding:"6px 16px",borderRadius:"20px",border:lang==="ta"?"none":"1px solid rgba(255,255,255,0.2)",background:lang==="ta"?"linear-gradient(135deg,#7C3AED,#9333EA)":"transparent",color:lang==="ta"?"#fff":"#94a3b8",fontWeight:600,cursor:"pointer"}} onClick={()=>setLang("ta")}>தமிழ்</button>
          <button style={{padding:"6px 16px",borderRadius:"20px",border:lang==="en"?"none":"1px solid rgba(255,255,255,0.2)",background:lang==="en"?"linear-gradient(135deg,#7C3AED,#9333EA)":"transparent",color:lang==="en"?"#fff":"#94a3b8",fontWeight:600,cursor:"pointer"}} onClick={()=>setLang("en")}>English</button>
        </div>
        <form onSubmit={handleSubmit}>
          <label style={S.label}>{L.name}</label>
          <input style={S.input} name="name" value={form.name} onChange={handleChange} placeholder="e.g. Murugan" required />
          <div style={S.row}>
            <div>
              <label style={S.label}>{L.dob}</label>
              <input style={{...S.input,marginBottom:0}} type="date" name="dob" value={form.dob} onChange={handleChange} required />
            </div>
            <div>
              <label style={S.label}>{L.time}</label>
              <input style={{...S.input,marginBottom:0}} type="time" name="time_of_birth" value={form.time_of_birth} onChange={handleChange} required />
            </div>
          </div>
          <label style={{...S.label,marginTop:"12px"}}>{L.place}</label>
          <input style={S.input} name="place_of_birth" value={form.place_of_birth} onChange={handleChange} placeholder="e.g. Chennai, Tamil Nadu" required />
          <button type="submit" style={{...S.btn,opacity:loading?0.7:1}} disabled={loading}>{loading ? L.loading : L.submit}</button>
        </form>
      </div>

      {error && <div style={S.err}><strong>Error:</strong> {error}</div>}

      {result && (
        <div ref={resultRef} style={S.card}>
          <div style={{...S.title,fontSize:"20px"}}>{result.name} - {result.place}</div>
          <div style={S.row}>
            <div style={S.box}><div style={S.boxLabel}>Rasi</div><div style={S.boxTa}>{result.tamil?.rasi||"-"}</div><div style={S.boxEn}>{result.english?.rasi||"-"}</div></div>
            <div style={S.box}><div style={S.boxLabel}>Lagnam</div><div style={S.boxTa}>{result.tamil?.lagnam||"-"}</div><div style={S.boxEn}>{result.english?.lagnam||"-"}</div></div>
          </div>
          <div style={S.box}><div style={S.boxLabel}>Nakshatra</div><div style={S.boxTa}>{result.tamil?.nakshatra||"-"}</div><div style={S.boxEn}>{result.english?.nakshatra||"-"} {result.english?.nakshatra_pada ? "(பாதம் "+result.english.nakshatra_pada+")" : ""}</div></div>
          <SouthIndianChart result={result} lang={lang} />
          {result.dasha?.slice(0,3).map((d,i)=>(
            <div key={i} style={S.box}>
              <div style={{color:"#f6d365",fontWeight:700}}>{d.dasha} {lang==="ta"?"தசா":"Dasa"}</div>
              <div style={{color:"#94a3b8",fontSize:"12px"}}>{fmtDate(d.start)} → {fmtDate(d.end)}</div>
              {d.bhukti?.slice(0,2).map((b,j)=>(
                <div key={j} style={{color:"#c4b5fd",fontSize:"12px",marginTop:"4px"}}>▪ {b.name}: {fmtDate(b.start)} → {fmtDate(b.end)}</div>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
